import { render, staticRenderFns } from "./ArticleCatalog.vue?vue&type=template&id=6994992e&scoped=true&"
import script from "./ArticleCatalog.vue?vue&type=script&lang=ts&"
export * from "./ArticleCatalog.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleCatalog.vue?vue&type=style&index=0&id=6994992e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6994992e",
  null
  
)

export default component.exports